import GraphQLClientService from '../../services/GraphQLClientService';
import { FlurstuckEntity } from "../../ResponseObjects/Schemas/FlurstuckEntity";
import { getAccessToken } from '../../authentication/useAccessToken';
import { Stage, GeometryType } from '../../constants/progress';
import { useProgressStore } from '../../store/progressStore';


export default async function fetchFlurstueckData(minX, minY, maxX, maxY,crs) {
  // Validate parameters
  //console.log(minX,minY,maxX,maxY)
  const updateProgress = useProgressStore.getState().updateProgress;
  const geometryType = GeometryType.SITE_PLOTS;
  if (minX === undefined || minY === undefined || maxX === undefined || maxY === undefined) {
    updateProgress(geometryType,{
      stage: Stage.ERROR,
      message: "Missing bounding box",
      error: "All boundary parameters (minX, minY, maxX, maxY) are required"
    });

    throw new Error('All boundary parameters (minX, minY, maxX, maxY) are required');
  }
  updateProgress(geometryType,
    {
      stage: Stage.QUERY,
      message:'Fetching data from server',
      progress: 25,
      error: null
    }
  )

  const query = `query ParcelByBounds 
  {
    parcelByBounds(
    minLat: ${maxY}
    minLon:${maxX}
    maxLat: ${minY}
    maxLon: ${minX}
    outputCRS: ${crs}
    revitProtocol: true
  ) {
    parcels {
      geometry
      officialArea
      cadastralDistrictName
      cadastralDistrictKey
      constructionArea
      grundstuecksflaeche
      parcelNumber
      municipalityKey
      municipalityName
      parcelIdentifier
      subsoilClass
      bmz
      windLoadZone
      snowLoadZone
      earthquakeZone
      gfz
      grz
      landuse
      
    }
  }
  }`;

  const client = new GraphQLClientService();
  
  //const token = await getAccessToken();
  try {
        const response = await client.executeQueryAsync(query);
        if(response == "TimedOUT")
        {
          updateProgress(geometryType,{
            stage: Stage.TIMEDOUT,
            message:"Timed out",
            progress:0,// need to change the progress       
          })
          return null;
        }
        else
        {
          if (response.data.parcelByBounds.parcels.length > 0) {
              updateProgress(geometryType,{
                stage: Stage.QUERYSTAGE,
                message:"Fetched data from the server",
                progress:50,// need to change the progress
                fetched: response.data.parcelByBounds.length
              })
            const flurstuckEntities = FlurstuckEntity.fromResponse(response,crs); // add a processing stage in the function if required
            updateProgress(geometryType,{
              stage: Stage.PROCESSINGSTAGE,
              message:"Processed fetched data from the server",
              progress:50,// need to change the progress
              processed: flurstuckEntities.length
            })
          
            return flurstuckEntities;
          } else {
              updateProgress(geometryType,{
                stage: Stage.NULL,
                message:'No data returned or an error occurred.',
                error:'No data returned or an error occurred.'
              })
              console.log('No data returned or an error occurred.');
              return null;
          }
        }
    
      
      } catch (error) {
          updateProgress(geometryType,{
            stage: Stage.ERROR,
            message:'Error during GraphQL request:',
            error: error
          })
          console.error('Error during GraphQL request:', error);
          throw error; 
        }
}